import React from 'react';
import { MessageCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { WHATSAPP_URL } from '../data/content';
const badges = ['Reembolso simple', 'Sin formularios', 'Te quedás con los bonos'];
export function Guarantee() {
  return <section className="bg-paper-soft px-5 py-20 lg:px-8" aria-labelledby="garantia" data-id="element-131" data-mp="1x4browvnqpas">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-132" data-mp="1x2ijve9b5z17">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-133" data-mp="19fsgo9l83yf0">
          Riesgo cero · 100% protegido
        </p>
        <ShieldCheckIcon className="mx-auto mt-6 h-10 w-10 text-grass" aria-hidden="true" data-id="element-134" data-mp="14dtev454t9k6" />
        <h2 id="garantia" className="display mt-5 text-3xl text-ink sm:text-4xl" data-id="element-135" data-mp="1j6n8rul5hs8d">
          Garantía de 7 días
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-136" data-mp="qo9eu62xqqek">
          Abrí todo el material. Usalo. Probalo en tus entrenamientos. Si el megapack
          no te cambia la forma de planificar y dirigir, te devuelvo cada peso. Sin
          preguntas.
        </p>
        <ul className="mt-8 flex flex-wrap justify-center gap-2" data-id="element-137" data-mp="oxfac9teapsk">
          {badges.map(badge => <li key={badge} className="rounded-full border border-paper-line bg-paper px-4 py-2 text-[13px] font-bold uppercase tracking-wide text-ink" data-id="element-138" data-mp="twi2itoa11j4">
              {badge}
            </li>)}
        </ul>
        <p className="mt-6 text-sm text-ink-dim" data-id="element-139" data-mp="61p7ylhjvre5">
          Satisfacción garantizada, o te devuelvo la plata.
        </p>
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-2 rounded-md border-2 border-ink px-6 py-3.5 text-sm font-extrabold uppercase tracking-tight text-ink transition-colors duration-150 ease-out hover:bg-ink hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink" data-id="element-140" data-mp="b0a5ue9bxyzf">
          <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-141" data-mp="3rigjym80mohs" />
          Tengo una duda: hablar por WhatsApp
        </a>
      </Reveal>
    </section>;
}